import { createReducer } from 'redux-act';
import actions from '../actions/taskManagementActions';

const initialState = {
    addTaskPending: false,
    addTaskRes: null,
    addTaskError: null,

    getAllTaskPending: false,
    getAllTaskRes: null,
    getAllTaskError: null,

    updateTaskPending: false,
    updateTaskRes: null,
    updateTaskError: null,

    deleteTaskPending: false,
    deleteTaskRes: null,
    deleteTaskError: null,

    addSubTaskPending: false,
    addSubTaskRes: null,
    addSubTaskError: null,

    getAllSubTaskPending: false,
    getAllSubTaskRes: null,
    getAllSubTaskError: null,

    updateSubTaskPending: false,
    updateSubTaskRes: null,
    updateSubTaskError: null,

    deleteSubTaskPending: false,
    deleteSubTaskRes: null,
    deleteSubTaskError: null,

    addTaskProjectPending: false,
    addTaskProjectRes: null,
    addTaskProjectError: null,

    getTaskProjectPending: false,
    getTaskProjectRes: null,
    getTaskProjectError: null,

    updateTaskProjectPending: false,
    updateTaskProjectRes: null,
    updateTaskProjectError: null,

    deleteTaskProjectPending: false,
    deleteTaskProjectRes: null,
    deleteTaskProjectError: null,

    getAllTaskProjectListPending: false,
    getAllTaskProjectListRes: null,
    getAllTaskProjectListError: null,

    saveTimeTrackingPending: false,
    saveTimeTrackingRes: null,
    saveTimeTrackingError: null,

    getTaskLogsPending: false,
    getTaskLogsRes: null,
    getTaskLogsError: null,

    taskReportPending: false,
    taskReportRes: null,
    taskReportError: null,

    taskStatusPending: false,
    taskStatusRes: null,
    taskStatusError: null,

    employeeWiseTaskPending: false,
    employeeWiseTaskRes: null,
    employeeWiseTaskError: null,

    taskGraphPending: false,
    taskGraphRes: null,
    taskGraphError: null,

    changeStatusPending: false,
    changeStatusRes: null,
    changeStatusError: null,

    changeDueDatePending: false,
    changeDueDateRes: null,
    changeDueDateError: null,

    addTaskFilePending: false,
    addTaskFileRes: null,
    addTaskFileError: null,

    getFilePending: false,
    getFileRes: null,
    getFileError: null,

    subTaskStatusPending: false,
    subTaskStatusRes: null,
    subTaskStatusError: null,

    getMyTaskPending: false,
    getMyTaskRes: null,
    getMyTaskError: null,


    selectedTaskDetail: null
};
/* Add Task Reducers */
const handleAddTaskRequest = state => {
    return {
        ...state,
        ...{
            addTaskPending: true,
            addTaskRes: null,
            addTaskError: null,
        },
    };
};
const handleAddTaskSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addTaskPending: false,
            addTaskRes: payload,
            addTaskError: null,
        },
    };
};
const handleAddTaskError = (state, payload) => ({
    ...state,
    ...{
        addTaskPending: false,
        addTaskRes: null,
        addTaskError: payload,
    },
});


/* Get All Task Reducers */
const handleGetAllTaskRequest = state => {
    return {
        ...state,
        ...{
            getAllTaskPending: true,
            getAllTaskRes: null,
            getAllTaskError: null,
        },
    };
};
const handleGetAllTaskSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAllTaskPending: false,
            getAllTaskRes: payload,
            getAllTaskError: null,
        },
    };
};
const handleGetAllTaskError = (state, payload) => ({
    ...state,
    ...{
        getAllTaskPending: false,
        getAllTaskRes: null,
        getAllTaskError: payload,
    },
});

/* Update Task Reducers */
const handleUpdateTaskRequest = state => {
    return {
        ...state,
        ...{
            updateTaskPending: true,
            updateTaskRes: null,
            updateTaskError: null,
        },
    };
};
const handleUpdateTaskSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            updateTaskPending: false,
            updateTaskRes: payload,
            updateTaskError: null,
        },
    };
};
const handleUpdateTaskError = (state, payload) => ({
    ...state,
    ...{
        updateTaskPending: false,
        updateTaskRes: null,
        updateTaskError: payload,
    },
});

/* Delete Task Reducers */
const handleDeleteTaskRequest = state => {
    return {
        ...state,
        ...{
            deleteTaskPending: true,
            deleteTaskRes: null,
            deleteTaskError: null,
        },
    };
};
const handleDeleteTaskSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            deleteTaskPending: false,
            deleteTaskRes: payload,
            deleteTaskError: null,
        },
    };
};
const handleDeleteTaskError = (state, payload) => ({
    ...state,
    ...{
        deleteTaskPending: false,
        deleteTaskRes: null,
        deleteTaskError: payload,
    },
});


/* Add Task Reducers */
const handleAddSubTaskRequest = state => {
    return {
        ...state,
        ...{
            addSubTaskPending: true,
            addSubTaskRes: null,
            addSubTaskError: null,
        },
    };
};
const handleAddSubTaskSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addSubTaskPending: false,
            addSubTaskRes: payload,
            addSubTaskError: null,
        },
    };
};
const handleAddSubTaskError = (state, payload) => ({
    ...state,
    ...{
        addSubTaskPending: false,
        addSubTaskRes: null,
        addSubTaskError: payload,
    },
});


/* Get All Task Reducers */
const handleGetAllSubTaskRequest = state => {
    return {
        ...state,
        ...{
            getAllSubTaskPending: true,
            getAllSubTaskRes: null,
            getAllSubTaskError: null,
        },
    };
};
const handleGetAllSubTaskSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAllSubTaskPending: false,
            getAllSubTaskRes: payload,
            getAllSubTaskError: null,
        },
    };
};
const handleGetAllSubTaskError = (state, payload) => ({
    ...state,
    ...{
        getAllSubTaskPending: false,
        getAllSubTaskRes: null,
        getAllSubTaskError: payload,
    },
});

/* Update Task Reducers */
const handleUpdateSubTaskRequest = state => {
    return {
        ...state,
        ...{
            updateSubTaskPending: true,
            updateSubTaskRes: null,
            updateSubTaskError: null,
        },
    };
};
const handleUpdateSubTaskSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            updateSubTaskPending: false,
            updateSubTaskRes: payload,
            updateSubTaskError: null,
        },
    };
};
const handleUpdateSubTaskError = (state, payload) => ({
    ...state,
    ...{
        updateSubTaskPending: false,
        updateSubTaskRes: null,
        updateSubTaskError: payload,
    },
});

/* Delete Task Reducers */
const handleDeleteSubTaskRequest = state => {
    return {
        ...state,
        ...{
            deleteSubTaskPending: true,
            deleteSubTaskRes: null,
            deleteSubTaskError: null,
        },
    };
};
const handleDeleteSubTaskSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            deleteSubTaskPending: false,
            deleteSubTaskRes: payload,
            deleteSubTaskError: null,
        },
    };
};
const handleDeleteSubTaskError = (state, payload) => ({
    ...state,
    ...{
        deleteSubTaskPending: false,
        deleteSubTaskRes: null,
        deleteSubTaskError: payload,
    },
});

const handleSelectedTaskDetailSuccess = (state, payload) => {
    return {
        ...state,
        ...{

            selectedTaskDetail: payload,
        },
    };
};

/*  add task Project Reducers */
const handleAddTaskProjectRequest = state => {
    return {
        ...state,
        ...{
            addTaskProjectPending: true,
            addTaskProjectRes: null,
            addTaskProjectError: null,
        },
    };
};
const handleAddTaskProjectSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addTaskProjectPending: false,
            addTaskProjectRes: payload,
            addTaskProjectError: null,
        },
    };
};
const handleAddTaskProjectError = (state, payload) => ({
    ...state,
    ...{
        addTaskProjectPending: false,
        addTaskProjectRes: null,
        addTaskProjectError: payload,
    },
});

/* Get Task Project Reducers */
const handleGetTaskProjectRequest = state1 => {
    return {
        ...state1,
        ...{
            getTaskProjectPending: true,
            getTaskProjectRes: null,
            getTaskProjectError: null,
        },
    };
};
const handleGetTaskProjectSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTaskProjectPending: false,
            getTaskProjectRes: payload,
            getTaskProjectError: null,
        },
    };
};
const handleGetTaskProjectError = (state1, payload) => ({
    ...state1,
    ...{
        getTaskProjectPending: false,
        getTaskProjectRes: null,
        getTaskProjectError: payload,
    },
});

/* Get All task Project List Reducers */
const handleGetAllTaskProjectListRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllTaskProjectListPending: true,
            getAllTaskProjectListRes: null,
            getAllTaskProjectListError: null,
        },
    };
};
const handleGetAllTaskProjectListSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllTaskProjectListPending: false,
            getAllTaskProjectListRes: payload,
            getAllTaskProjectListError: null,
        },
    };
};
const handleGetAllTaskProjectListError = (state1, payload) => ({
    ...state1,
    ...{
        getAllTaskProjectListPending: false,
        getAllTaskProjectListRes: null,
        getAllTaskProjectListError: payload,
    },
});

/* Update  task  Project Reducers */
const handleUpdateTaskProjectRequest = state1 => {
    return {
        ...state1,
        ...{
            updateTaskProjectPending: true,
            updateTaskProjectRes: null,
            updateTaskProjectError: null,
        },
    };
};
const handleUpdateTaskProjectSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateTaskProjectPending: false,
            updateTaskProjectRes: payload,
            updateTaskProjectError: null,
        },
    };
};
const handleUpdateTaskProjectError = (state1, payload) => ({
    ...state1,
    ...{
        updateTaskProjectPending: false,
        updateTaskProjectRes: null,
        updateTaskProjectError: payload,
    },
});


/* Delete task Project Reducers */
const handleDeleteTaskProjectRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteTaskProjectPending: true,
            deleteTaskProjectRes: null,
            deleteTaskProjectError: null,
        },
    };
};
const handleDeleteTaskProjectSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteTaskProjectPending: false,
            deleteTaskProjectRes: payload,
            deleteTaskProjectError: null,
        },
    };
};
const handleDeleteTaskProjectError = (state1, payload) => ({
    ...state1,
    ...{
        deleteTaskProjectPending: false,
        deleteTaskProjectRes: null,
        deleteTaskProjectError: payload,
    },
});

/*Save Time Tracking Reducers */
const handleSaveTimeTrackingRequest = state1 => {
    return {
        ...state1,
        ...{
            saveTimeTrackingPending: true,
            saveTimeTrackingRes: null,
            saveTimeTrackingError: null,
        },
    };
};
const handleSaveTimeTrackingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            saveTimeTrackingPending: false,
            saveTimeTrackingRes: payload,
            saveTimeTrackingError: null,
        },
    };
};
const handleSaveTimeTrackingError = (state1, payload) => ({
    ...state1,
    ...{
        saveTimeTrackingPending: false,
        saveTimeTrackingRes: null,
        saveTimeTrackingError: payload,
    },
});

/*Get Task Logs Reducers */
const handleGetTaskLogsRequest = state1 => {
    return {
        ...state1,
        ...{
            getTaskLogsPending: true,
            getTaskLogsRes: null,
            getTaskLogsError: null,
        },
    };
};
const handleGetTaskLogsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTaskLogsPending: false,
            getTaskLogsRes: payload,
            getTaskLogsError: null,
        },
    };
};
const handleGetTaskLogsError = (state1, payload) => ({
    ...state1,
    ...{
        getTaskLogsPending: false,
        getTaskLogsRes: null,
        getTaskLogsError: payload,
    },
});


/*Get Task Report Reducers */
const handleTaskReportRequest = state1 => {
    return {
        ...state1,
        ...{
            taskReportPending: true,
            taskReportRes: null,
            taskReportError: null,
        },
    };
};
const handleTaskReportSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            taskReportPending: false,
            taskReportRes: payload,
            taskReportError: null,
        },
    };
};
const handleTaskReportError = (state1, payload) => ({
    ...state1,
    ...{
        taskReportPending: false,
        taskReportRes: null,
        taskReportError: payload,
    },
});


/*Task Status Reducers */
const handleTaskStatusRequest = state1 => {
    return {
        ...state1,
        ...{
            taskStatusPending: true,
            taskStatusRes: null,
            taskStatusError: null,
        },
    };
};
const handleTaskStatusSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            taskStatusPending: false,
            taskStatusRes: payload,
            taskStatusError: null,
        },
    };
};
const handleTaskStatusError = (state1, payload) => ({
    ...state1,
    ...{
        taskStatusPending: false,
        taskStatusRes: null,
        taskStatusError: payload,
    },
});


/*Employee Wise Task Reducers */
const handleEmployeeWiseTaskRequest = state1 => {
    return {
        ...state1,
        ...{
            employeeWiseTaskPending: true,
            employeeWiseTaskRes: null,
            employeeWiseTaskError: null,
        },
    };
};
const handleEmployeeWiseTaskSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            employeeWiseTaskPending: false,
            employeeWiseTaskRes: payload,
            employeeWiseTaskError: null,
        },
    };
};
const handleEmployeeWiseTaskError = (state1, payload) => ({
    ...state1,
    ...{
        employeeWiseTaskPending: false,
        employeeWiseTaskRes: null,
        employeeWiseTaskError: payload,
    },
});

/*Task Graph Reducers */
const handleTaskGraphRequest = state1 => {
    return {
        ...state1,
        ...{
            taskGraphPending: true,
            taskGraphRes: null,
            taskGraphError: null,
        },
    };
};
const handleTaskGraphSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            taskGraphPending: false,
            taskGraphRes: payload,
            taskGraphError: null,
        },
    };
};
const handleTaskGraphError = (state1, payload) => ({
    ...state1,
    ...{
        taskGraphPending: false,
        taskGraphRes: null,
        taskGraphError: payload,
    },
});


/*Task Graph Reducers */
const handleChangeStatusRequest = state1 => {
    return {
        ...state1,
        ...{
            changeStatusPending: true,
            changeStatusRes: null,
            changeStatusError: null,
        },
    };
};
const handleChangeStatusSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            changeStatusPending: false,
            changeStatusRes: payload,
            changeStatusError: null,
        },
    };
};
const handleChangeStatusError = (state1, payload) => ({
    ...state1,
    ...{
        changeStatusPending: false,
        changeStatusRes: null,
        changeStatusError: payload,
    },
});


/*Task Graph Reducers */
const handleChangeDueDateRequest = state1 => {
    return {
        ...state1,
        ...{
            changeDueDatePending: true,
            changeDueDateRes: null,
            changeDueDateError: null,
        },
    };
};
const handleChangeDueDateSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            changeDueDatePending: false,
            changeDueDateRes: payload,
            changeDueDateError: null,
        },
    };
};
const handleChangeDueDateError = (state1, payload) => ({
    ...state1,
    ...{
        changeDueDatePending: false,
        changeDueDateRes: null,
        changeDueDateError: payload,
    },
});


/*add Task Graph Reducers */
const handleAddTaskFileRequest = state1 => {
    return {
        ...state1,
        ...{
            addTaskFilePending: true,
            addTaskFileRes: null,
            addTaskFileError: null,
        },
    };
};
const handleAddTaskFileSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            addTaskFilePending: false,
            addTaskFileRes: payload,
            addTaskFileError: null,
        },
    };
};
const handleAddTaskFileError = (state1, payload) => ({
    ...state1,
    ...{
        addTaskFilePending: false,
        addTaskFileRes: null,
        addTaskFileError: payload,
    },
});

/*add Task Graph Reducers */
const handleGetTaskFileRequest = state1 => {
    return {
        ...state1,
        ...{
            getTaskFilePending: true,
            getTaskFileRes: null,
            getTaskFileError: null,
        },
    };
};
const handleGetTaskFileSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTaskFilePending: false,
            getTaskFileRes: payload,
            getTaskFileError: null,
        },
    };
};
const handleGetTaskFileError = (state1, payload) => ({
    ...state1,
    ...{
        getTaskFilePending: false,
        getTaskFileRes: null,
        getTaskFileError: payload,
    },
});


/*Sub Task Status Reducers */
const handleSubTaskStatusRequest = state1 => {
    return {
        ...state1,
        ...{
            subTaskStatusPending: true,
            subTaskStatusRes: null,
            subTaskStatusError: null,
        },
    };
};
const handleSubTaskStatusSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            subTaskStatusPending: false,
            subTaskStatusRes: payload,
            subTaskStatusError: null,
        },
    };
};
const handleSubTaskStatusError = (state1, payload) => ({
    ...state1,
    ...{
        subTaskStatusPending: false,
        subTaskStatusRes: null,
        subTaskStatusError: payload,
    },
});


/*get My Task Reducers */
const handleGetMyTaskRequest = state1 => {
    return {
        ...state1,
        ...{
            getMyTaskPending: true,
            getMyTaskRes: null,
            getMyTaskError: null,
        },
    };
};
const handleGetMyTaskSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getMyTaskPending: false,
            getMyTaskRes: payload,
            getMyTaskError: null,
        },
    };
};
const handleGetMyTaskError = (state1, payload) => ({
    ...state1,
    ...{
        getMyTaskPending: false,
        getMyTaskRes: null,
        getMyTaskError: payload,
    },
});










/* Clear Task Store */
const clearTaskStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_ADD_TASK_STORE':
            return {
                ...state,
                ...{
                    addTaskPending: false,
                    addTaskRes: null,
                    addTaskError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_TASK_STORE':
            return {
                ...state,
                ...{
                    updateTaskPending: false,
                    updateTaskRes: null,
                    updateTaskError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_TASK_STORE':
            return {
                ...state,
                ...{
                    deleteTaskPending: false,
                    deleteTaskRes: null,
                    deleteTaskError: null,
                },
            };

        case 'HANDLE_CLEAR_ADD_SUB_TASK_STORE':
            return {
                ...state,
                ...{
                    addSubTaskPending: false,
                    addSubTaskRes: null,
                    addSubTaskError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_SUB_TASK_STORE':
            return {
                ...state,
                ...{
                    updateSubTaskPending: false,
                    updateSubTaskRes: null,
                    updateSubTaskError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_SUB_TASK_STORE':
            return {
                ...state,
                ...{
                    deleteSubTaskPending: false,
                    deleteSubTaskRes: null,
                    deleteSubTaskError: null,
                },
            };

        case 'HANDLE_CLEAR_ADD_TASK_PROJECT_STORE':
            return {
                ...state,
                ...{
                    addTaskProjectPending: false,
                    addTaskProjectRes: null,
                    addTaskProjectError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_TASK_PROJECT_STORE':
            return {
                ...state,
                ...{
                    updateTaskProjectPending: false,
                    updateTaskProjectRes: null,
                    updateTaskProjectError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_TASK_PROJECT_STORE':
            return {
                ...state,
                ...{
                    deleteTaskProjectPending: false,
                    deleteTaskProjectRes: null,
                    deleteTaskProjectError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_TASK_PROJECT_STORE':
            return {
                ...state,
                ...{
                    getTaskProjectPending: false,
                    getTaskProjectRes: null,
                    getTaskProjectError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_ALL_TASK_PROJECT_LIST_STORE':
            return {
                ...state,
                ...{
                    getAllTaskProjectListPending: false,
                    getAllTaskProjectListRes: null,
                    getAllTaskProjectListError: null,
                },
            };

        case 'HANDLE_CLEAR_TASK_STATUS_STORE':
            return {
                ...state,
                ...{
                    getTaskStatusPending: false,
                    getTaskStatusRes: null,
                    getTaskStatusError: null,
                },
            };
        case 'HANDLE_CLEAR_CHANGE_STATUS_STORE':
            return {
                ...state,
                ...{
                    changeStatusPending: false,
                    changeStatusRes: null,
                    changeStatusError: null,
                },
            };
        case 'HANDLE_CLEAR_CHANGE_DUE_DATE_STORE':
            return {
                ...state,
                ...{
                    changeDueDatePending: false,
                    changeDueDateRes: null,
                    changeDueDateError: null,
                },
            };
        case 'HANDLE_CLEAR_ADD_TASK_FILE_STORE':
            return {
                ...state,
                ...{
                    addTaskFilePending: false,
                    addTaskFileRes: null,
                    addTaskFileError: null,

                },
            };
        case 'HANDLE_CLEAR_TASK_REPORT_STORE':
            return {
                ...state,
                ...{
                    taskReportPending: false,
                    taskReportRes: null,
                    taskReportError: null,
                },
            };

        case 'HANDLE_CLEAR_SAVE_TIME_TRACKING_STORE':
            return {
                ...state,
                ...{
                    saveTimeTrackingPending: false,
                    saveTimeTrackingRes: null,
                    saveTimeTrackingError: null,
                },
            };

        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.addTaskRequest]: handleAddTaskRequest,
        [actions.addTaskSuccess]: handleAddTaskSuccess,
        [actions.addTaskError]: handleAddTaskError,

        [actions.getAllTaskRequest]: handleGetAllTaskRequest,
        [actions.getAllTaskSuccess]: handleGetAllTaskSuccess,
        [actions.getAllTaskError]: handleGetAllTaskError,

        [actions.updateTaskRequest]: handleUpdateTaskRequest,
        [actions.updateTaskSuccess]: handleUpdateTaskSuccess,
        [actions.updateTaskError]: handleUpdateTaskError,

        [actions.deleteTaskRequest]: handleDeleteTaskRequest,
        [actions.deleteTaskSuccess]: handleDeleteTaskSuccess,
        [actions.deleteTaskError]: handleDeleteTaskError,

        [actions.addSubTaskRequest]: handleAddSubTaskRequest,
        [actions.addSubTaskSuccess]: handleAddSubTaskSuccess,
        [actions.addSubTaskError]: handleAddSubTaskError,

        [actions.getAllSubTaskRequest]: handleGetAllSubTaskRequest,
        [actions.getAllSubTaskSuccess]: handleGetAllSubTaskSuccess,
        [actions.getAllSubTaskError]: handleGetAllSubTaskError,

        [actions.updateSubTaskRequest]: handleUpdateSubTaskRequest,
        [actions.updateSubTaskSuccess]: handleUpdateSubTaskSuccess,
        [actions.updateSubTaskError]: handleUpdateSubTaskError,

        [actions.deleteSubTaskRequest]: handleDeleteSubTaskRequest,
        [actions.deleteSubTaskSuccess]: handleDeleteSubTaskSuccess,
        [actions.deleteSubTaskError]: handleDeleteSubTaskError,

        [actions.addTaskProjectRequest]: handleAddTaskProjectRequest,
        [actions.addTaskProjectSuccess]: handleAddTaskProjectSuccess,
        [actions.addTaskProjectError]: handleAddTaskProjectError,

        [actions.getTaskProjectRequest]: handleGetTaskProjectRequest,
        [actions.getTaskProjectSuccess]: handleGetTaskProjectSuccess,
        [actions.getTaskProjectError]: handleGetTaskProjectError,

        [actions.getAllTaskProjectListRequest]: handleGetAllTaskProjectListRequest,
        [actions.getAllTaskProjectListSuccess]: handleGetAllTaskProjectListSuccess,
        [actions.getAllTaskProjectListError]: handleGetAllTaskProjectListError,

        [actions.updateTaskProjectRequest]: handleUpdateTaskProjectRequest,
        [actions.updateTaskProjectSuccess]: handleUpdateTaskProjectSuccess,
        [actions.updateTaskProjectError]: handleUpdateTaskProjectError,

        [actions.deleteTaskProjectRequest]: handleDeleteTaskProjectRequest,
        [actions.deleteTaskProjectSuccess]: handleDeleteTaskProjectSuccess,
        [actions.deleteTaskProjectError]: handleDeleteTaskProjectError,

        [actions.saveTimeTrackingRequest]: handleSaveTimeTrackingRequest,
        [actions.saveTimeTrackingSuccess]: handleSaveTimeTrackingSuccess,
        [actions.saveTimeTrackingError]: handleSaveTimeTrackingError,

        [actions.getTaskLogsRequest]: handleGetTaskLogsRequest,
        [actions.getTaskLogsSuccess]: handleGetTaskLogsSuccess,
        [actions.getTaskLogsError]: handleGetTaskLogsError,

        [actions.taskReportRequest]: handleTaskReportRequest,
        [actions.taskReportSuccess]: handleTaskReportSuccess,
        [actions.taskReportError]: handleTaskReportError,

        [actions.taskStatusRequest]: handleTaskStatusRequest,
        [actions.taskStatusSuccess]: handleTaskStatusSuccess,
        [actions.taskStatusError]: handleTaskStatusError,

        [actions.employeeWiseTaskRequest]: handleEmployeeWiseTaskRequest,
        [actions.employeeWiseTaskSuccess]: handleEmployeeWiseTaskSuccess,
        [actions.employeeWiseTaskError]: handleEmployeeWiseTaskError,


        [actions.taskGraphRequest]: handleTaskGraphRequest,
        [actions.taskGraphSuccess]: handleTaskGraphSuccess,
        [actions.taskGraphError]: handleTaskGraphError,

        [actions.changeStatusRequest]: handleChangeStatusRequest,
        [actions.changeStatusSuccess]: handleChangeStatusSuccess,
        [actions.changeStatusError]: handleChangeStatusError,

        [actions.changeDueDateRequest]: handleChangeDueDateRequest,
        [actions.changeDueDateSuccess]: handleChangeDueDateSuccess,
        [actions.changeDueDateError]: handleChangeDueDateError,

        [actions.addTaskFileRequest]: handleAddTaskFileRequest,
        [actions.addTaskFileSuccess]: handleAddTaskFileSuccess,
        [actions.addTaskFileError]: handleAddTaskFileError,

        [actions.getTaskFileRequest]: handleGetTaskFileRequest,
        [actions.getTaskFileSuccess]: handleGetTaskFileSuccess,
        [actions.getTaskFileError]: handleGetTaskFileError,

        [actions.subTaskStatusRequest]: handleSubTaskStatusRequest,
        [actions.subTaskStatusSuccess]: handleSubTaskStatusSuccess,
        [actions.subTaskStatusError]: handleSubTaskStatusError,
        
        [actions.getMyTaskRequest]: handleGetMyTaskRequest,
        [actions.getMyTaskSuccess]: handleGetMyTaskSuccess,
        [actions.getMyTaskError]: handleGetMyTaskError,

        [actions.selectedTaskDetail]: handleSelectedTaskDetailSuccess,
        [actions.handleClearTaskStore]: clearTaskStore,
    },
    initialState,
);